import React from 'react';
import './Sidebar.css';
import { Link } from 'react-router-dom';

function Sidebar({ tabs, activeTab, setActiveTab, navAriaLabel }) {
    return (
        <aside className="profile-sidebar">
            <nav className="profile-sidebar__nav" aria-label={navAriaLabel}>
                <ul className="profile-tabs">
                    {tabs.map((tab) => {
                        const IconComponent = tab.icon;
                        const isActive = activeTab === tab.id;
                        const isLogout = tab.id === 'logout';
                        const tabClassName = [
                            'profile-tab',
                            isActive ? 'profile-tab-active' : '',
                            isLogout ? 'profile-tab--logout' : '',
                        ]
                            .filter(Boolean)
                            .join(' ');

                        if (tab.isLink) {
                            return (
                                <li key={tab.id} className="profile-tabs__item">
                                    <Link
                                        to={tab.path}
                                        className={tabClassName}
                                        aria-current={isActive ? 'page' : undefined}
                                    >
                                        <span className="profile-tab-content">
                                            <IconComponent size={18} aria-hidden />
                                            <span className="profile-tab-label">{tab.label}</span>
                                        </span>
                                    </Link>
                                </li>
                            );
                        }

                        return (
                            <li key={tab.id} className="profile-tabs__item">
                                <button
                                    type="button"
                                    onClick={() => setActiveTab(tab.id)}
                                    className={tabClassName}
                                    aria-current={isActive ? 'true' : undefined}
                                >
                                    <span className="profile-tab-content">
                                        <IconComponent size={18} aria-hidden />
                                        <span className="profile-tab-label">{tab.label}</span>
                                    </span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </aside>
    );
}

export default Sidebar;
